@if (singleBetPickState$ | async; as singleBetPickState) {
    <div #singlePickTemplate bsNavigateToBetslip class="quick-bet-pick">
        <ng-container
            *ngTemplateOutlet="
                pickTemplate;
                context: {
                    pick: pick,
                    messages: messages,
                    showEachWay: singleBetPickState.isEachWay,
                    betslipType: betslipType$ | async,
                    hideActionButton: false,
                    hideLineSwitcher: true,
                    marketLogoTooltipAppendTo: 'bs-quick-bet',
                    marketLogoTooltipBoundaries: 'bs-quick-bet',
                    marketLogoTooltipPlacement: 'top-start',
                    marketLogoTrackingLocation: 'quickbet',
                    hideEventName: true,
                }
            " />
        <bs-digital-pick-odds class="single-odds" [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat" />
    </div>
}
